import { Loader2 } from 'lucide-react'

/**
 * Full-page blocking state shown while a founder's LinkedIn disconnect is being
 * processed (status === 'DISCONNECTING'). No dashboard chrome, no campaign
 * controls — the campaign is paused and our team handles the disconnect
 * manually. Mirrors the OutreachComingSoon container so it reads as a peer
 * full-page state.
 */
export function OutreachDisconnectingView() {
  return (
    <div className="mx-auto max-w-6xl py-6">
      <div className="flex min-h-[calc(100vh-12rem)] flex-col items-center justify-center text-center">
        <div className="mb-5 inline-flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.14em] text-muted-foreground">
          <Loader2 className="size-3 animate-spin" />
          Disconnecting
        </div>
        <h1 className="max-w-xl text-[28px] font-bold leading-tight tracking-[-0.02em] text-foreground">
          Disconnecting your account
        </h1>
        <p className="mt-4 max-w-lg text-[14.5px] leading-relaxed text-muted-foreground">
          Your campaign is paused. Your LinkedIn will be disconnected from our system within 1
          working day. You can set everything up again afterwards.
        </p>
      </div>
    </div>
  )
}
